import classNames from 'classnames';
import { Underlying } from 'models/underlying';

type Props = { underlying: Underlying };
export function UnderlyingTooltipIcon({ underlying }: Props) {
  return (
    <button className="btn btn-icon p-0" type="button">
      <i
        className={classNames('icon text-secondary', {
          'text-warning': underlying.isRestricted,
        })}
        data-e2e="selected-underlying-item-info"
      >
        info_outline
      </i>
    </button>
  );
}
